import type { WorkOrderSummary } from '@ck/domain'

function normalizedNumber(value: string | null | undefined): string {
  return (value ?? '').trim().toUpperCase()
}

export function resolvePaymentWorkOrder(
  number: string,
  selectedId: string,
  options: WorkOrderSummary[],
  originalNumber: string | null = null
): { id: string | null; error: string | null } {
  const normalized = normalizedNumber(number)
  if (!normalized) return { id: null, error: null }

  if (selectedId && normalizedNumber(originalNumber) === normalized && originalNumber) {
    return { id: selectedId, error: null }
  }

  const match = options.find((option) => normalizedNumber(option.number) === normalized)
  return match
    ? { id: match.id, error: null }
    : { id: null, error: 'Selecione uma ordem de serviço válida na lista.' }
}
